export default __webpack_public_path__ + "static/media/bashan.92ec06b9.png";